import * as utils from '../../utils';
import * as templates from './formTemplates';

export const ADDRESS_FORM_TYPE = {
	OFFICE: 'office',
	INTERNATIONAL: 'international',
	US: 'us',
};

/**
 * Helper function to determine whether or not the user has the US or
 * a default country selected.
 *
 * This is used to determine
 * 1. Whether or not we should show the state dropdown
 * 2. Whether or not we should display Zip Code vs Country Code
 */
export const isSelectedCountryUSOrDefault = country => {
	return country === null || country === 'US' || country === '--select--';
};

export const isValidZip = zip => {
	return zip && zip.length > 0 ? utils.isValidZipCode(zip) : true;
};

export const isValidCountryCode = code => {
	return code && code.length > 0 ? !!code : true;
};

export const getFormTemplate = formType => {
	switch (formType) {
		case ADDRESS_FORM_TYPE.INTERNATIONAL:
		case ADDRESS_FORM_TYPE.US:
			return templates.defaultInternationalAddressFormConfig;
		case ADDRESS_FORM_TYPE.OFFICE:
		default:
			return templates.defaultOfficeAddressFormConfig;
	}
};
